import sfetch from "../commons/utils/super-fetch";

export function sendToServerForValidation(
  payload: {},
  validateEndpoint: string
): Promise<Response> {
  return sfetch(validateEndpoint, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  });
}
